<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import Footer from "@/components/Footer";
import NavbarSecond from "@/components/NavbarSecond.vue";
import NavbarSecondDark from "@/components/NavbarSecondDark.vue";
import { reactive, ref } from "@vue/reactivity";
import { onBeforeMount } from "@vue/runtime-core";
import axios from "axios";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Venue from "./Venue.vue";
import ImgDestination1 from "@/assets/samples/destination1.png";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

let store = useStore();
let route = useRoute();
let navbarDark = ref(false);
let floatingDark = ref(false);
let destination = reactive({
  data: null,
  loading: false,
  photo_active: null,
});
let filter = ref("");

onBeforeMount(() => {
  destination.loading = true;
  axios
    .get(`${store.state.urlNewEventFront}destination/${route.params.id}`)
    .then((res) => {
      destination.data = res.data.data;
      destination.photo_active = res.data.data.photos[0].path_formated;
      destination.loading = false;
    })
    .catch((err) => {
      console.log(err);
      destination.loading = false;
    });
});

// onscroll
document.addEventListener("scroll", function () {
  if (window.pageYOffset > 590) {
    navbarDark.value = true;
  } else {
    navbarDark.value = false;
  }

  if (window.pageYOffset > 250) {
    floatingDark.value = true;
  } else {
    floatingDark.value = false;
  }
});
</script>

<style scoped>
.destination {
  .bg-flower {
    position: absolute;
    bottom: -120px;
    left: 0;
    overflow: hidden;
    width: 400px;
    height: 400px;
    z-index: 2;
    background-image: url('../../assets/2024/images/flower-destination.png');
    background-size: cover;
    background-repeat: no-repeat;
  }

  .card-banner {
    min-height: 85vh;
    border-radius: 0px 0px 2.5rem 2.5rem;
  }

  @media (max-width: 576px) {

    /* col-sm */
    .bg-flower {
      bottom: 16rem;
      width: 18rem;
      height: 18rem;
      z-index: 1;
    }
    .card-banner {
      min-height: 65vh;
      border-radius: 0px 0px 1.5rem 1.5rem;
    }
  }
}
</style>
<template>
  <div class="destination">
    <NavbarSecond v-if="!navbarDark" />
    <NavbarSecondDark v-else />
    <section class="p-0" style="overflow: hidden">
      <div class="row text-center">
        <div class="col-lg-12">
          <div class="card bg-white text-white shadow border-0 position-relative card-banner"
            :style="`background-image: url('${destination.photo_active || ImgDestination1}'); background-size: cover; background-position: center;`">
            <div class="bg-overlay"></div>
          </div>
        </div>
      </div>
      <div class="bg-flower"></div>
    </section>
    <section class="container" style="margin-top: -20vh;">
      <div class="card shadow border-0" style="border-radius: 2rem; z-index: 3;">
        <div class="card-body">
          <p class="text-primary-mice h1 fw-bold text-center text-lg-start" style="padding: 12px 15px;">{{ destination.data?.name }}</p>
          <div class="ql-editor text-primary-mice" v-html="destination.data?.description"></div>
        </div>
      </div>
    </section>
    <section class="container-xl my-5">&nbsp;</section>
    <section class="container-xl mb-5 px-lg-5">
      <div class="row d-lg-none">
        <div class="col-12">
          <div class="h3">{{$t('findA')}} {{ filter || "Venue" }}</div>
          <p class="text-secondary small">
            {{ $t('findADesc') }}
          </p>
        </div>
        <div class="col-12">
          <select v-model="filter" class="form-select">
            <option value="">{{$t('filter')}}</option>
            <option value="convention">Convention</option>
            <option value="hotel">Hotel</option>
            <option value="hall">Hall</option>
            <option value="restaurant">Restaurant</option>
          </select>
        </div>
      </div>
      <div class="d-none d-lg-flex justify-content-between align-items-center px-lg-5">
        <div class="col-9">
          <div class="h3">{{$t('findA')}} {{ filter || "Venue" }}</div>
          <p class="text-secondary small" style="max-width: 500px">
            {{ $t('findADesc') }}
          </p>
        </div>
        <div>
          <select v-model="filter" class="form-select">
            <option value="">{{$t('filter')}}</option>
            <option value="convention">Convention</option>
            <option value="hotel">Hotel</option>
            <option value="hall">Hall</option>
            <option value="restaurant">Restaurant</option>
          </select>
        </div>
      </div>
    </section>
    <Venue :type="filter" />
    <!-- <Hotel v-if="filter == 'hotel'" /> -->
    <Footer />
  </div>
</template>
